module.exports = __webpack_public_path__ + "img/mute.336da052.svg";